<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-custom h5 p-2">
    <!--  Show this only on mobile to medium screens  -->

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarToggle"
      aria-controls="navbarToggle"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!--  Use flexbox utility classes to change how the child elements are justified  -->
    <div
      class="collapse navbar-collapse justify-content-around"
      id="navbarToggle"
    >
      <ul class="navbar-nav">
        <li class="nav-item m-3">
          <router-link to="/" tag="li">
            <a class="nav-link">Home</a>
          </router-link>
        </li>
        <li class="nav-item m-3">
          <a
            class="nav-link"
            href="https://unadulterated-fort.000webhostapp.com/forums/"
            >Forums</a
          >
        </li>
        <li class="nav-item m-3">
          <a class="nav-link" href="https://discord.gg/ct6yKW5h">Discord</a>
        </li>
      </ul>
      <!--   Show this only lg screens and up   -->
      <a class="navbar-brand d-none d-lg-block m-5" href="#"
        ><img src="../../assets/yourlogo.png" alt="YOURLOGO"
      /></a>
      <ul class="navbar-nav">
        <li class="nav-item m-3">
          <router-link to="/vote" tag="li">
            <a class="nav-link">Vote</a>
          </router-link>
        </li>
        <li class="nav-item m-3">
          <router-link to="/store" tag="li">
            <a class="nav-link">Store</a>
          </router-link>
        </li>
        <li class="nav-item m-3" tag="li">
          <router-link to="/hiscores">
            <a class="nav-link">Hiscores</a>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
nav li:hover a,
nav li.router-link-active a,
nav li.router-link-exact-active {
  color: white !important;
  cursor: pointer;
}
a {
  text-decoration: none;
}
.bg-custom {
  background-color: rgba(0, 0, 0, 0.479);
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  nav {
    font-size: 16px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (max-width: 1100px) {
  nav {
    font-size: 16px;
  }
}
</style>